"use client"

import { AlertTriangle, X } from "lucide-react"
import { Button } from "@/components/ui/button"

interface DeleteConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  studentName: string
}

export function DeleteConfirmModal({ isOpen, onClose, onConfirm, studentName }: DeleteConfirmModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50">
      {/* Blurry Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300"
        onClick={onClose}
      />
      
      {/* Modal Container */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
          {/* Modal Header */}
          <div className="bg-red-600 px-6 py-4 flex justify-between items-center">
            <div className="flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-white" />
              <h3 className="text-lg leading-6 font-bold text-white">Confirm Deletion</h3>
            </div>
            <button 
              onClick={onClose} 
              className="text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white/50 rounded-full p-1 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          
          {/* Modal Content */}
          <div className="px-6 py-6">
            <p className="text-sm text-gray-900">
              Are you sure you want to delete the report records for{" "}
              <span className="font-bold text-red-600">{studentName}</span>?
            </p>
            <p className="text-sm text-gray-600 mt-2">This action cannot be undone.</p>
          </div>
          
          {/* Modal Footer */}
          <div className="bg-gray-50 px-6 py-4 flex flex-col-reverse sm:flex-row sm:justify-end gap-3 border-t border-gray-200">
            <Button 
              type="button" 
              variant="outline" 
              onClick={onClose}
              className="border-gray-300 hover:bg-gray-100 text-gray-700"
            >
              Cancel
            </Button>
            <Button 
              onClick={onConfirm} 
              className="bg-red-600 hover:bg-red-700 text-white focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            >
              Delete Report
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}